// @flow

import { Component } from 'react';

import {
    createLiveStreamingDialogEvent,
    sendAnalytics
} from '../../../analytics';
import { JitsiRecordingConstants } from '../../../base/lib-jitsi-meet';

// CUSTOM
import { FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V2 } from '../../../customise/constant';
import { streamingSocket } from '../../../customise/custom/toolbar/recording-streaming';
import { setDefaultRecordingType } from '../../../customise/redux/tool-webjam-v2/actions';
import { setRecording } from '../../../customise/redux/tool-webjam/actions';
import { getBaseConfig, _ValidateIPaddress } from '../../../customise/Utils';
import { getRecordingStreamingType } from '../../../customise/welcome-dashboard/Request.d';
import { NOTIFICATION_TIMEOUT_TYPE, showErrorNotification, showNotification } from '../../../notifications';
import { Constant, CURRENT_ROOM_NAME } from '../../../webjam/constant';
import toast from 'react-simple-toasts';
import { hideDialog } from '../../../base/dialog';
import { ct } from '../../../customise/constant-Utils';
// END

/**
 * The type of the React {@code Component} props of
 * {@link AbstractStartLiveStreamDialog}.
 */
export type Props = {

    /**
     * The {@code JitsiConference} for the current conference.
     */
    _conference: Object,

    /**
     * The current state of interactions with the Google API. Determines what
     * Google related UI should display.
     */
    _googleAPIState: number,

    /**
     * The email of the user currently logged in to the Google web client
     * application.
     */
    _googleProfileEmail: string,

    /**
     * The live stream key that was used before.
     */
    _streamKey: string,

    /**
     * The Redux dispatch function.
     */
    dispatch: Function,

    /**
     * Invoked to obtain translated strings.
     */
    t: Function
}

/**
 * The type of the React {@code Component} state of
 * {@link AbstractStartLiveStreamDialog}.
 */
export type State = {

    /**
     * Details about the broadcasts available for use for the logged in Google
     * user's YouTube account.
     */
    broadcasts: ?Array<Object>,

    /**
     * The error type, as provided by Google, for the most recent error
     * encountered by the Google API.
     */
    errorType: ?string,

    /**
     * The boundStreamID of the broadcast currently selected in the broadcast
     * dropdown.
     */
    selectedBoundStreamID: ?string,

    /**
     * The selected or entered stream key to use for YouTube live streaming.
     */
    streamKey: string
};

/**
 * Implements an abstract class for the StartLiveStreamDialog on both platforms.
 *
 * NOTE: Google log-in is not supported for mobile yet for later implementation
 * but the abstraction of its properties are already present in this abstract
 * class.
 */
export default class AbstractStartLiveStreamDialog<P: Props>
    extends Component<P, State> {
    _isMounted: boolean;

    /**
     * Constructor of the component.
     *
     * @inheritdoc
     */
    constructor(props: P) {
        super(props);

        this.state = {
            broadcasts: undefined,
            errorType: undefined,
            selectedBoundStreamID: undefined,
            streamKey: ''
        };

        /**
         * Instance variable used to flag whether the component is or is not
         * mounted. Used as a hack to avoid setting state on an unmounted
         * component.
         *
         * @private
         * @type {boolean}
         */
        this._isMounted = false;

        this._onCancel = this._onCancel.bind(this);
        this._onStreamKeyChange = this._onStreamKeyChange.bind(this);
        this._onSubmit = this._onSubmit.bind(this);
    }

    /**
     * Implements {@link Component#componentDidMount()}. Invoked immediately
     * after this component is mounted.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentDidMount() {
        this._isMounted = true;
    }

    /**
     * Implements React's {@link Component#componentWillUnmount()}. Invoked
     * immediately before this component is unmounted and destroyed.
     *
     * @inheritdoc
     */
    componentWillUnmount() {
        this._isMounted = false;
    }

    _onCancel: () => boolean;

    /**
     * Invokes the passed in {@link onCancel} callback and closes
     * {@code StartLiveStreamDialog}.
     *
     * @private
     * @returns {boolean} True is returned to close the modal.
     */
    _onCancel() {
        sendAnalytics(createLiveStreamingDialogEvent('start', 'cancel.button'));

        return true;
    }

    /**
     * Asks the user to sign in, if not already signed in, and then requests a
     * list of the user's YouTube broadcasts.
     *
     * NOTE: To be implemented by platforms.
     *
     * @private
     * @returns {Promise}
     */
    _onGetYouTubeBroadcasts: () => Promise<*>;

    _onStreamKeyChange: string => void;

    /**
     * Callback invoked to update the {@code StartLiveStreamDialog} component's
     * display of the entered YouTube stream key.
     *
     * @param {string} streamKey - The stream key entered in the field.
     * @private
     * @returns {void}
     */
    _onStreamKeyChange(streamKey) {
        this._setStateIfMounted({
            streamKey,
            selectedBoundStreamID: undefined
        });
    }

    _onSubmit: () => boolean;

    /**
     * Invokes the passed in {@link onSubmit} callback with the entered stream
     * key, and then closes {@code StartLiveStreamDialog}.
     *
     * @private
     * @returns {boolean} False if no stream key is entered to preventing
     * closing, true to close the modal.
     */

    // CUSTOM
    startStreamApi = (recIpAddress) => {
        const { broadcasts, selectedBoundStreamID } = this.state;
        let key
            = (this.state.streamKey || this.props._streamKey || '').trim();

        if (getBaseConfig('multiStream')) {
            let allKeys = JSON.parse(key);
            key = allKeys?.youtubeStreamId || 'xyx-xyx-xyx-xyx'
        }

        const { roomorIpAddress, dispatch } = this.props;
        let recIpAddressNew = recIpAddress;
        let isIp = _ValidateIPaddress(roomorIpAddress);
        let url;
        let noChangedRoomName = getBaseConfig('noChangedRoomName')
        if (noChangedRoomName == true) {
            recIpAddressNew = roomorIpAddress;
            isIp = _ValidateIPaddress(roomorIpAddress);
            url = Constant.App.ServerUrl + '/start-audio-route?isIP=' + isIp + '&roomname=' + roomorIpAddress + '&server=' + getBaseConfig("serverVarRecordingStreaming") + `&name=${roomorIpAddress}&processtype=recording` + `&visibleRoom=${CURRENT_ROOM_NAME}`;
        } else {
            url = Constant.App.ServerUrl + '/start-audio-route?isIP=' + isIp + '&roomname=' + roomorIpAddress + '&server=' + getBaseConfig("serverVarRecordingStreaming") + `&name=${recIpAddressNew}&processtype=recording`;
        }

        axios.get(url).then(response => {
            if (!response?.data?.status && response?.data?.type == 1) {
                stopRecStream(false, '')
                dispatch(showErrorNotification({
                    titleKey: 'Busy server',
                    descriptionKey: response.data.message
                }));
                return false;
            } else {
                setTimeout(() => {
                    let selectedBroadcastID = null;
                    if (selectedBoundStreamID) {
                        const selectedBroadcast = broadcasts && broadcasts.find(
                            broadcast => broadcast.boundStreamID === selectedBoundStreamID);
                        selectedBroadcastID = selectedBroadcast && selectedBroadcast.id;
                    }

                    sendAnalytics(
                        createLiveStreamingDialogEvent('start', 'confirm.button'));

                    this.props._conference.startRecording({
                        broadcastId: selectedBroadcastID,
                        mode: JitsiRecordingConstants.mode.STREAM,
                        streamId: key
                    });
                }, 5000);
                return true;
            }
        }).catch(error => {
            console.log("Invalid START streaming =>", error);
            return false;
        });
    }
    // END

    // CUSTOM
    // _onSubmit() {
    async _onSubmit() {
        // END
        const { broadcasts, selectedBoundStreamID } = this.state;
        let key
            = (this.state.streamKey || this.props._streamKey || '').trim();

        // CUSTOM
        const { usersData, roomorIpAddress, isHybridSession, dispatch, authOrganization } = this.props;
        if (!key || key == '') {
            toast(ct("Translate.validations.liveStreamEmpty"), Constant.App.ToastTime.LongCloseTime)
            return false;
        } else {
            dispatch(hideDialog());
        }

        let allKeys;
        if (getBaseConfig('multiStream')) {
            allKeys = JSON.parse(key);
            key = allKeys?.youtubeStreamId || 'xyx-xyx-xyx-xyx'
        }

        let recIpAddress = roomorIpAddress;

        dispatch(setRecording({
            streamingStarted: 1
        }))

        let isJibriRecording = true; // check if recording is Started with jibri based on avstack
        let recordingTypeRes = await getRecordingStreamingType('?organization_id=' + authOrganization?._id)

        if (recordingTypeRes.data.status) {
            dispatch(setDefaultRecordingType(recordingTypeRes.data.data.recording_type));
            isJibriRecording = recordingTypeRes.data.data.recording_type == "JIBRI";
        }

        if (isJibriRecording == false) {
            if (_ValidateIPaddress(recIpAddress) && usersData && !isHybridSession) {
                this.startStreamApi(recIpAddress);
                return true;
            } else if (usersData && !isHybridSession) {
                this.startStreamApi(recIpAddress);
                return true;
            } else {
                // END
                let selectedBroadcastID = null;

                if (selectedBoundStreamID) {
                    const selectedBroadcast = broadcasts && broadcasts.find(
                        broadcast => broadcast.boundStreamID === selectedBoundStreamID);

                    selectedBroadcastID = selectedBroadcast && selectedBroadcast.id;
                }

                sendAnalytics(
                    createLiveStreamingDialogEvent('start', 'confirm.button'));

                this.props._conference.startRecording({
                    broadcastId: selectedBroadcastID,
                    mode: JitsiRecordingConstants.mode.STREAM,
                    streamId: key
                });

                return true;
                // CUSTOM
            }
        } else {
            let selectedBroadcastID = null;
            if (selectedBoundStreamID) {
                const selectedBroadcast = broadcasts && broadcasts.find(
                    broadcast => broadcast.boundStreamID === selectedBoundStreamID);
                selectedBroadcastID = selectedBroadcast && selectedBroadcast.id;
            }

            sendAnalytics(
                createLiveStreamingDialogEvent('start', 'confirm.button'));

            this.props._conference.startRecording({
                broadcastId: selectedBroadcastID,
                mode: JitsiRecordingConstants.mode.STREAM,
                streamId: key,
                appData: JSON.stringify({
                    youtubeStreamId: allKeys?.youtubeStreamId,
                    tiktokStreamId: allKeys?.tiktokStreamId,
                    facebookStreamId: allKeys?.facebookStreamId,
                })
            });

            // show custom notification for init the streaming
            dispatch(showNotification({
                descriptionKey: 'liveStreaming.pending',
                titleKey: 'dialog.liveStreaming',
                customActionNameKey: ["liveStreaming.prepare"],
                uid: "liveStreaming.prepare"
            }, NOTIFICATION_TIMEOUT_TYPE.STICKY));

            dispatch(streamingSocket(true))

            return true;
        }
        // END
    }

    /**
     * Updates the internal state if the component is still mounted. This is a
     * workaround for all the state setting that occurs after ajax.
     *
     * @param {Object} newState - The new state to merge into the existing
     * state.
     * @private
     * @returns {void}
     */
    _setStateIfMounted(newState) {
        if (this._isMounted) {
            this.setState(newState);
        }
    }
}

/**
 * Maps part of the Redux state to the component's props.
 *
 * @param {Object} state - The Redux state.
 * @returns {{
 *     _conference: Object,
 *     _googleAPIState: number,
 *     _googleProfileEmail: string,
 *     _streamKey: string
 * }}
 */
export function _mapStateToProps(state: Object) {
    return {
        _conference: state['features/base/conference'].conference,
        _googleAPIState: state['features/google-api'].googleAPIState,
        _googleProfileEmail: state['features/google-api'].profileEmail,
        _streamKey: state['features/recording'].streamKey,
        // CUSTOM
        usersData: state[FEATURE_CUSTOM_REDUX].usersData,
        roomorIpAddress: state[FEATURE_CUSTOM_REDUX].roomorIpAddress,
        isHybridSession: state[FEATURE_CUSTOM_REDUX].isHybridSession,
        authOrganization: state[FEATURE_CUSTOM_REDUX_V2].authOrganization,
        // END
    };
}
